$(() => {
    // если экран больше
    if (Modernizr.mq("screen and (min-width: 1024px)")) {
        // задаём 2му уровню категорий ширину основного контейнера
        let navWidth = $(".main-container").width();
        $(".navigator-inner").width(navWidth);
    }
    // Открытие второго уровня категорий на тач устройствах
    if (Modernizr.touchevents) {
        $(".navigator-list__link").click(function(e) {
            e.preventDefault();
        });
        $(".js-nav").on("click", function() {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this)
                    .children("a")
                    .removeClass("active");
                $(this)
                    .children(".js-nav-container")
                    .removeClass("active");
            } else {
                $(this).addClass("active");
                $(this)
                    .children("a")
                    .addClass("active");
                $(this)
                    .children(".js-nav-container")
                    .addClass("active");
            }
        });
    } else {
        // открытие второго уровня категорий
        $("body")
            .on("mousemove", ".js-nav", function() {
                $(this)
                    .children("a")
                    .addClass("active");
                $(this)
                    .children(".js-nav-container")
                    .addClass("active");
            })
            .on("mouseleave", ".js-nav", function() {
                $(this)
                    .children("a")
                    .removeClass("active");
                $(this)
                    .children(".js-nav-container")
                    .removeClass("active");
            });
    }
    // открытие каталогна на маленьких экрана
    $("body").on("click", ".js-nav-hamburger", function() {
        $(".navigator-main").toggleClass("active");
    });
});



// WEBPACK FOOTER //
// ./markup/components/aside/aside.js